import { Controller } from "@hotwired/stimulus"

// Gives a Trix rich text field a focused, full-screen writing mode.
// Connects to data-controller="rich-editor"
export default class extends Controller {
  static targets = ["editor"]
  static classes = ["fullscreen"]

  connect() {
    this.phone = window.matchMedia("(max-width: 767px)")
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    this.unlock()
    document.removeEventListener("keydown", this.onKeydown, true)
  }

  // Tapping into the editor on a phone goes straight to full screen
  openOnPhone() {
    if (this.phone.matches) this.open()
  }

  open() {
    if (this.isOpen) return

    this.isOpen = true
    this.element.classList.add(this.fullscreenClass)
    document.documentElement.classList.add("rich-editor-open")
    // Capture phase, so we see Escape before Trix closes its link dialog and
    // clears the dialog's active marker
    document.addEventListener("keydown", this.onKeydown, true)

    // Let the layout settle, then put the cursor in the text
    requestAnimationFrame(() => this.editorTarget.focus())
  }

  close() {
    if (!this.isOpen) return

    this.isOpen = false
    this.unlock()
    document.removeEventListener("keydown", this.onKeydown, true)
    this.editorTarget.blur()
    this.element.scrollIntoView({ block: "center" })
  }

  unlock() {
    this.element.classList.remove(this.fullscreenClass)
    document.documentElement.classList.remove("rich-editor-open")
  }

  onKeydown(event) {
    if (event.key !== "Escape") return

    // While Trix's link dialog is open, Escape should only close that dialog
    if (this.element.querySelector("trix-toolbar [data-trix-active]")) return

    event.preventDefault()
    this.close()
  }
}
